import { getApiHost } from '@/shared/lib/utils/env';

/**
 * Полный адрес записи диалога по параметрам подписанной ссылки
 * (`url` из GET /conversation/{id}/signed-url).
 */
export const buildConversationAudioUrl = (signedUrl: string): string =>
  `${getApiHost()}/conversation/signed-link/${signedUrl}`;
